import { z } from "zod";
import { vacationDaysAccrualTypes } from "../../absences";

export const halfVacationDaySchema = z.object({
	day: z.number().min(1).max(31),
	month: z.number().min(1).max(12),
});

export type HalfDayDate = z.infer<typeof halfVacationDaySchema>;

export const absenceGeneralBaseFormSchema = z.object({
	vacationDays: z.number(),
	halfVacationDays: z
		.array(halfVacationDaySchema)
		.default([])
		.transform((days) => {
			const seen = new Set<string>();
			return days.filter(({ day, month }) => {
				const key = `${day}-${month}`;
				if (seen.has(key)) return false;
				seen.add(key);
				return true;
			});
		}),
	vacationDaysAccrualType: z.enum(vacationDaysAccrualTypes),
	vacationDaysExpire: z.boolean(),
	vacationDaysExpireAtDay: z.number().nullable(),
	vacationDaysExpireAtMonth: z.number().nullable(),
});

export const absenceGeneralFormSchema = absenceGeneralBaseFormSchema
	.transform((values) => {
		if (!values.vacationDaysExpire) {
			values.vacationDaysExpireAtDay = null;
			values.vacationDaysExpireAtMonth = null;
		}
		return values;
	})
	.superRefine((values, context) => {
		if (values.vacationDaysExpire) {
			if (!values.vacationDaysExpireAtDay) {
				context.addIssue({
					code: "custom",
					message: "Day required.",
					path: ["vacationDaysExpireAtDay"],
				});
			}
			if (!values.vacationDaysExpireAtMonth) {
				context.addIssue({
					code: "custom",
					message: "Month required.",
					path: ["vacationDaysExpireAtMonth"],
				});
			}
		}
	});

export type AbsenceGeneralFormSchema = z.infer<typeof absenceGeneralFormSchema>;
